import get from 'lodash/get';

export default (page: object) => {
  return get(page, 'authentication.signupLink');
};
